import { alert } from './alert';
import { notify } from './notify';

export default {
  alert,
  notify,
};